import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Maybe } from 'graphql/jsutils/Maybe';
import { faArrowTurnUp } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { NotificationActionButton } from '@components/Notifications/shared';

type Props = {
  isSaved: Maybe<boolean>;
  onClick: () => void;
  spotifyLink: string | undefined;
};

export function NotificationVariant({ isSaved, onClick, spotifyLink }: Props) {
  return (
    <div>
      <NotificationActionButton
        icon={<FontAwesomeIcon icon={faArrowTurnUp} className="-rotate-90" />}
        onClick={onClick}
        label={isSaved ? 'Presaved' : 'Presave'}
        href={spotifyLink}
      />
    </div>
  );
}
